(function (module) {
    "use strict";

    module.service("scoringCardPriceLoadService", ['$q', scoringCardPriceLoadService]);

    function scoringCardPriceLoadService(this: $TSFixMe, $q: ng.IQService) {
        const service = this;

        service.buttonTranslationKey = 'FORECAST.PRODUCT.MKSHR_BRAND_IN_MARKET.LOAD_PRICE_SC';

        service.getPrices = (brand: $TSFixMe, parameters: $TSFixMe) => {
            
            var forecastLength = Math.floor(moment.utc(parameters.forecastEndDate).diff(moment.utc(parameters.forecastStartDate), 'months')) + 1;

            var dict = {};

            for (const sku of brand.skus) {
                // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                dict[sku.oracleIndex] = createMonthlyArrayFromYearlyData(sku.forecast.yearlyData, 'price', parameters.forecastStartDate, forecastLength);
            }

            return $q.when(dict);
        }

        function createMonthlyArrayFromYearlyData(yearlyData: $TSFixMe, property: $TSFixMe, forecastStartDate: $TSFixMe, forecastLength: $TSFixMe) {
            let array = new Array(forecastLength);
            
            var month = moment.utc(forecastStartDate);
            for (let i = 0; i < forecastLength; i++) {
                
                const yearData = yearlyData[_.sortedIndex(yearlyData, { year: month.year() }, "year")];
                if (yearData) {

                    array[i] = angular._get(yearData, property);
                } else {
                    array[i] = null;
                }

                month.add(1, 'months');
            }
            return array;
        }
    }


})(angular.module('topline.services'));